import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { Button } from '../../../subkit-ui';
import LandingPageCallToAction from './CallToAction';
import LandingPageCheckmarkList from './CheckmarkList';
import LandingPageFooter from './Footer';
import LandingPageGridRow from './GridRow';
import LandingPageImageAndList from './ImageAndList';
import LandingPageSignup from './Signup';
import LandingPageTestamonial from './Testamonial';
import LandingPageTextAndImage from './TextAndImage';
import LandingPageTopBar from './TopBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LandingPage = function LandingPage(props) {
  return /*#__PURE__*/_jsxs("div", {
    children: [props.topBar && /*#__PURE__*/_jsx(LandingPageTopBar, _objectSpread({}, props.topBar)), !props.topBar && /*#__PURE__*/_jsx("div", {
      className: "mt-8 flex justify-center",
      children: /*#__PURE__*/_jsx("img", {
        className: "my-auto self-start",
        src: "/images/img_logo.png",
        style: {
          height: '36px'
        },
        alt: "Subkit Logo"
      })
    }), props.header && /*#__PURE__*/_jsx("div", {
      className: "mt-18 px-4 md:px-0 flex justify-center",
      children: /*#__PURE__*/_jsxs("div", {
        className: "md:max-w-4xl flex flex-column md:text-center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "font-serif text-3xl md:text-5xl leading-snug md:leading-snug px-2 text-gray-900 md:w-4/5 md:mx-auto",
          children: props.header.title
        }), /*#__PURE__*/_jsx("div", {
          className: "flex justify-center",
          children: /*#__PURE__*/_jsx("div", {
            className: "mt-4 px-1 text-gray-900 max-w-full md:max-w-threequarters font-dmsans text-xl",
            children: props.header.description
          })
        }), props.header.buttonText && props.header.buttonLink && /*#__PURE__*/_jsx("div", {
          className: "flex justify-center",
          children: /*#__PURE__*/_jsx(Button, {
            classes: "mt-12 py-3 px-12 font-dmsans fw-700",
            text: props.header.buttonText,
            href: props.header.buttonLink,
            "data-cy": "LandingPageHeaderButton"
          })
        })]
      })
    }), props.imageHref && /*#__PURE__*/_jsx("div", {
      className: "flex justify-center px-4 md:px-0 mt-10",
      children: /*#__PURE__*/_jsx("img", {
        src: props.imageHref,
        className: "max-w-full md:max-w-threequarters self-start"
      })
    }), props.signup && /*#__PURE__*/_jsx("div", {
      className: "mt-12",
      children: /*#__PURE__*/_jsx(LandingPageSignup, _objectSpread({}, props.signup))
    }), props.textAndImage && /*#__PURE__*/_jsx("div", {
      className: "mt-18",
      children: /*#__PURE__*/_jsx(LandingPageTextAndImage, _objectSpread({}, props.textAndImage))
    }), props.checkmarkList && /*#__PURE__*/_jsx("div", {
      className: "mt-8",
      children: /*#__PURE__*/_jsx(LandingPageCheckmarkList, _objectSpread({}, props.checkmarkList))
    }), props.testamonial && /*#__PURE__*/_jsx("div", {
      className: "md:mt-16",
      children: /*#__PURE__*/_jsx(LandingPageTestamonial, _objectSpread({}, props.testamonial))
    }), props.gridRow && /*#__PURE__*/_jsx("div", {
      className: "mt-18",
      children: /*#__PURE__*/_jsx(LandingPageGridRow, _objectSpread({}, props.gridRow))
    }), props.imageAndList && /*#__PURE__*/_jsx("div", {
      className: "mt-16",
      children: /*#__PURE__*/_jsx(LandingPageImageAndList, _objectSpread({}, props.imageAndList))
    }), props.callToAction && /*#__PURE__*/_jsx(LandingPageCallToAction, _objectSpread({}, props.callToAction)), /*#__PURE__*/_jsx("div", {
      className: "",
      children: /*#__PURE__*/_jsx(LandingPageFooter, {})
    })]
  });
};

export default LandingPage;